_props$getUserConfirm